module.exports = __webpack_public_path__ + "img/nophoto.653b76c7.png";